var e, t;
function s() {
  if (t) return e;
  t = 1;
  return e = class {
    constructor(e) {
      this.result = [], this.search = e, this.selected = void 0, this.maxResults = void 0, this.includeOnlyCities = [], this.includeOnlyStates = [], this.includeOnlyZIPCodes = [], this.excludeStates = [], this.preferCities = [], this.preferStates = [], this.preferZIPCodes = [], this.preferRatio = void 0, this.preferGeolocation = void 0, this.source = void 0, this.customParameters = {};
    }
    addCustomParameter(e, t) {
      this.customParameters[e] = t;
    }
  };
}
export { s as __require };